// Export a enum of config types that we can use to ensure that we are always using the correct keys.
// This will help prevent typos and other errors.

export const ConfigTypesValues = [
    /**
     * This is the key for the google client id that is used for the google login.
     */
    'google_client_id',

    /**
     * This is the key for the google maps api key that is used for the google maps.
     */
    'google_maps_api_key',

    /**
     * This is the url for the production screen. when we generate the QR code, this is the url that is used.
     */
    'productionscreen_url',

    /**
     * The licence key for AG Grid enterprise.
     */
    'aggrid_licence_key',

    /**
     * The base url to the EQ Live page used for previewing the live data.
     */
    'livepreview_url',

    /**
     * The maximum file size in bytes that can be uploaded.
     * Default is 5MB (1024 * 1024 * 5).
     */
    'max_file_size',
] as const;

export type ConfigTypes = (typeof ConfigTypesValues)[number];
